import styled from '@emotion/styled'
import tw from 'twin.macro'
import { Cross, Heading } from '@pretamanger/component-library'

export const FlyOutTrigger = styled('div')`
  ${tw`w-full flex z-30 bg-white items-center justify-around py-3 border-b-[1px]`}
`

export const FlyOutTriggerButton = styled.button`
  ${tw`cursor-pointer`}
`

export const FlyOutContainer = styled.div`
  ${tw`
    z-40 top-0 left-0 h-screen w-screen overflow-y-auto bg-white
    transform transition-transform duration-300 ease-in-out`}
  ${({ open }) => (open ? tw`absolute translate-x-0` : tw`-translate-x-full`)}
  height: fill-available;
`

export const FlyOutHeader = styled.div`
  ${tw`
    sticky z-10 top-0 lg:relative lg:top-auto
    w-full grid gap-4 py-4 px-0 border-b
  `}
  background-color: inherit;
  grid-template-columns: auto 3rem;
  place-items: center; /* BPS-469 use place-items-center when Tailwind updated to v2 */
`

export const FlyOutTitle = styled(Heading)`
  ${tw`font-body`}
`

export const CloseButton = styled.button`
  ${tw`h-12 w-12 grid`}
  outline-offset: -0.2rem;
  place-items: center; /* use place-items-center when Tailwind updated */
`

export const CrossIcon = styled(Cross)`
  ${tw`h-4 w-4`}
`
